var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-crud',_vm._b({scopedSlots:_vm._u([{key:"entityFormSlot",fn:function(ref){
var entity = ref.entity;
return [(entity.id === _vm.userData.id)?_c('admin-update-password',{attrs:{"user":entity}}):_vm._e()]}}])},'entity-crud',{ model: _vm.model, title: _vm.title, tableColumns: _vm.tableColumns, filter: _vm.filter, formColumns: _vm.formColumns, defaultEntity: _vm.defaultEntity },false))}
var staticRenderFns = []

export { render, staticRenderFns }